<div>
  <div class="dm-flex dm-justify-center dm-margin-bottom-16">
    <dm-badge i18n="@@page.fehler.badge" [color]="'error'" [dot]="true">Fehler {{ errorNumber() }}</dm-badge>
  </div>

  @switch (errorNumber()) {
    @case (404) {
      <h1
        i18n="@@page.fehler.nichtGefundenTitel"
        class="dm-margin-bottom-16 desktop:dm-margin-bottom-24 dm-text-display-md desktop:dm-text-display-xl dm-text-weight-semibold dm-text-align-center"
      >
        Seite nicht gefunden
      </h1>
      <p i18n="@@page.fehler.nichtGefundenBeschreibung" class="dm-text-lg desktop:dm-text-xl dm-text-align-center">
        Die gesuchte Seite existiert nicht oder wurde verschoben.
      </p>
    }
    @case (403) {
      <h1
        i18n="@@page.fehler.verbotenTitel"
        class="dm-margin-bottom-16 desktop:dm-margin-bottom-24 dm-text-display-md desktop:dm-text-display-xl dm-text-weight-semibold dm-text-align-center"
      >
        Verboten
      </h1>
      <p i18n="@@page.fehler.verbotenBeschreibung" class="dm-text-lg desktop:dm-text-xl dm-text-align-center">
        Diese Seite kann nicht angezeigt werden.
      </p>
    }
    @default {
      <h1
        i18n="@@page.fehler.titel"
        class="dm-margin-bottom-16 desktop:dm-margin-bottom-24 dm-text-display-md desktop:dm-text-display-xl dm-text-weight-semibold dm-text-align-center"
      >
        Fehler
      </h1>
      <p i18n="@@page.fehler.beschreibung" class="dm-text-lg desktop:dm-text-xl dm-text-align-center">
        Es ist ein Fehler aufgetreten. Bitte in ein paar Minuten erneut versuchen.
      </p>
    }
  }

  <div class="dm-flex dm-justify-center dm-flex-column desktop:dm-flex-row dm-margin-top-32 dm-gap-12 desktop:dm-margin-top-48">
    <dm-button color="secondary" [mobilegrow]="true" (click)="goBack()">
      <div class="dm-flex dm-items-center dm-gap-6">
        <dm-icon name="arrow-left" />
        <span i18n="@@page.fehler.zurueck">Zurück</span>
      </div>
    </dm-button>
    <dm-button i18n="@@page.fehler.zurStartseite" [mobilegrow]="true" (click)="goHome()">Zur Startseite</dm-button>
  </div>
</div>
